import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    //登陆
    {
        path: '/UserLogin',
        component: () => import('@/components/UserLogin.vue'),
        meta: { title: '登录页面' }
    },
    //账号密码登录
    {
        path: '/AccountLogin',
        component: () => import('@/components/AccountLogin.vue')
    },
    // 企业微信登录回调
    {
        path: '/wx_login_callback',
        component: () => import('@/components/WxLoginCallback.vue'),
        meta: { title: '企业微信登录回调' }
    },
    //验证失败
    {
        path: '/403',
        component: () => import('@/components/403.vue'),
        meta: { title: '访问失败' }
    },
    //测试
    {
        path: '/test',
        component: () => import('@/components/cms/test.vue'),
    },
    //sys系统
    {
        path: '/sys',
        component: () => import('@/components/sys/Sys.vue'),
        children: [
            {
                path: '/sys',
                component: () => import('@/components/sys/DashList.vue'),
                meta: { title: '首页' }
            },
            // sys系统
            {
                path: '/sysUser',
                component: () => import('@/components/sys/SysUser.vue'),
                meta: { title: '用户管理' }
            },
            // cms系统
            // 企业信息
            {
                path: '/cmsContact',
                component: () => import('@/components/cms/CmsContact.vue'),
                meta: { title: '企业信息' }
            },
            // 资料下载
            {
                path: '/cmsDownLoadList',
                component: () => import('@/components/cms/CmsDownLoadList.vue'),
                meta: { title: '资料下载' }
            },
            // 新增资料
            {
                path: '/addDownLoad',
                component: () => import('@/components/cms/AddDownLoad.vue'),
                meta: { title: '新增资料' }
            },
            // 修改资料
            {
                path: '/editDownLoad',
                component: () => import('@/components/cms/EditDownLoad.vue'),
                meta: { title: '修改资料' }
            },
            // 产品管理
            {
                path: '/cmsProducts',
                component: () => import('@/components/cms/CmsProducts.vue'),
                meta: { title: '产品管理' }
            },
            // 添加产品
            {
                path: '/addProduct',
                component: () => import('@/components/cms/AddProduct.vue'),
                meta: { title: '添加产品' }
            },
            // 修改产品
            {
                path: '/editProduct',
                component: () => import('@/components/cms/EditProduct.vue'),
                meta: { title: '修改产品' }
            },
            // 产品类型管理
            {
                path: '/cmsProductType',
                component: () => import('@/components/cms/CmsProductType.vue'),
                meta: { title: '产品类型管理' }
            },
            // 品牌管理
            {
                path: '/cmsBrand',
                component: () => import('@/components/cms/CmsBrand.vue'),
                meta: { title: '品牌管理' }
            },
            // 方案管理
            {
                path: '/cmsSolutionList',
                component: () => import('@/components/cms/CmsSolutionList.vue'),
                meta: { title: '方案管理' }
            },
            // 方案管理
            {
                path: '/cmsBanner',
                component: () => import('@/components/cms/CmsBanner.vue'),
                meta: { title: '轮播图管理' }
            },
            // erp首页
            {
                path: '/erpIndex',
                component: () => import('@/components/erp/index.vue'),
                meta: { title: 'erp首页' }
            },
            // erp授权信息列表
            {
                path: '/erpAuthorization',
                component: () => import('@/components/erp/Authorization.vue'),
                meta: { title: '授权信息' }
            },
            // erp新增授权信息
            {
                path: '/addAuthorization',
                component: () => import('@/components/erp/AddAuthorization.vue'),
                meta: { title: '新增授权信息' }
            },
            // erp编辑授权信息
            {
                path: '/editAuthorization',
                component: () => import('@/components/erp/EditAuthorization.vue'),
                meta: { title: '编辑授权信息' }
            },
            // erp授权日志列表
            {
                path: '/erpAuthorizationLog',
                component: () => import('@/components/erp/AuthorizationLog.vue'),
                meta: { title: '授权日志' }
            },
            // OA-任务列表
            {
                path: '/taskList',
                component: () => import('@/components/oa/taskList.vue'),
                meta: { title: 'erp首页' }
            }
        ]
    },
    
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.afterEach((to) => {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    } else {
      document.title = '晟源科技'; // 默认标题
    }
  });

export default router;